import React from 'react';
import { AgPhase3FileMetadata } from '@indigo-ag/schema';
import { Body } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { PhaseSection, utils } from 'shared';
import { PledgeCertificateDocumentSummary } from 'features/brazil-grower/components/shared/PledgeCertificateDocumentSummary/PledgeCertificateDocumentSummary';

interface PledgeCertificateDataSectionProps {
  pledgeCertificateFileInfo?: AgPhase3FileMetadata;
}

export const PledgeCertificateDataSection: React.FunctionComponent<PledgeCertificateDataSectionProps> = ({
  pledgeCertificateFileInfo
}) => {
  return (
    <PhaseSection title={i18next.t('certificateOfPledge')}>
      {pledgeCertificateFileInfo ? (
        <PledgeCertificateDocumentSummary phase3FileInfo={pledgeCertificateFileInfo} />
      ) : (
        <Body>{utils.text.firstLetterUppercase(i18next.t('noPledgeCertificateMessage'))}</Body>
      )}
    </PhaseSection>
  );
};
